import { Component, ElementRef, Input, TemplateRef, ViewChild, OnInit, OnChanges } from '@angular/core';
import { PaginationService } from '../PaginationService';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { AuService } from '../qms/au/au.service';
import { qmsService } from '../qms/qms.service';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';

@Component({
  selector: 'app-user-events',
  templateUrl: './user-events.component.html',
  styleUrls: ['./user-events.component.scss']
})
export class UserEventsComponent implements OnInit, OnChanges {

  @Input() data: any;
  isProcessing: boolean = true;
  searchValue: any;
  todayDate = new Date();
  datePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: true,
    todayPosition: 'center'
  }

  datepickerDateCustomClasses: DatepickerDateCustomClasses[];

  columnList: any = [{ column: "Event Name", width: "200px" }, { column: "Details", width: "200px" }, { column: "Event Start Date", width: "180px" }, { column: "Event End Date", width: "180px" },
  { column: "Involved Users", width: "200px" }, { column: "Created On", width: "180px" }, { column: "Created By", width: "200px" }
    , { column: "Updated On", width: "180px" }, { column: "Updated By", width: "200px" }]
  showingRowsText = "Showing rows";
  perPage = 5;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, public message: messageService, private readonly elem: ElementRef,
    public qmsservice: qmsService, public auService: AuService, public paginationService: PaginationService, private readonly snackBar: MatSnackBar) { }
  dropDownForDesignationCode: any;
  dropDownForDepartmentCode: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  ngOnInit() {
    const now = new Date();

    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
  }

  eventsList: any;
  ngOnChanges() {
    this.isProcessing = true;
    this.appService.getUserEvents(this.data).subscribe((data: any) => {
      this.isProcessing = false;
      this.eventsList = data;
    })
  }

  refreshGrid() {
    this.ngOnChanges();
  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.eventsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.eventsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any): void {

    const isChecked: boolean = e.target.checked === true;

    this.childCheckBoxs = isChecked;

    for (const eventItem of this.eventsList ?? []) {
      eventItem.childCheckBoxs = isChecked;
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  openAddPopup() {
    this.title = "Add Event";
    this.visibleEditButton = false;
    this.visibleAddButton = true;
    this.eventData = {};
    this.eventData.involvedUserIds = Number(this.message.getUserId());
    this.eventData.involvedUserNames = localStorage.getItem("loggedUserName");
    this.eventData.eventStartDate = new Date();
    this.eventData.eventEndDate = null;
    this.visibleAddEventPopup = this.dialog.open(this.addEventPopup, this.addEventPopupPopupConfig);
  }


  openEditPopup(eventData: any, event: any) {
    this.visibleEditButton = true;
    this.visibleAddButton = false;
    this.title = "Update Event";
    this.isProcessing = true;
    this.appService.getEventById(eventData.eventId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.eventData = data[0];
        if (this.eventData.eventStartDate != null) {
          this.eventData.eventStartDate = new Date(this.eventData.eventStartDate);
        }
        if (this.eventData.eventEndDate != null) {
          this.eventData.eventEndDate = new Date(this.eventData.eventEndDate);
        }
      })
    this.visibleAddEventPopup = this.dialog.open(this.addEventPopup, this.addEventPopupPopupConfig);
  }

  visibleAddEventPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addEventPopup', { static: true }) addEventPopup: TemplateRef<any>;


  addEventPopupPopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  };

  visibleDeleteEventPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('deleteEventPopup', { static: true }) deleteEventPopup: TemplateRef<any>;


  deleteEventPopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  eventData: any = {};

  isSubmitted = false;

  validateField(field: string) {
    if (this.eventData[field]) {
      this.isSubmitted = false;
    }
  }
  departmentSearchText: string = '';
  designationSearchText: string = '';
  addEventFunction(data: any) {
    this.isSubmitted = true;

    if (!data.eventName || !data.eventEndDate || !data.eventDetails) {
      return;
    }
    if (this.visibleAddButton) {
      this.isProcessing = true;


      this.appService.createTodaysEvent(data).subscribe((response: any) => {
        this.isProcessing = false;

        const isSuccess = response.resultType === 'S';

        if (isSuccess) {
          this.ngOnChanges();
          this.visibleAddEventPopup.close();
        }

        const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: isSuccess ? 5000 : undefined,
          data: {
            message: response.result,
            type: isSuccess ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: isSuccess ? 'Success' : 'Error',
        });

        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      });
    } else {
      delete this.eventData['createdOn'];
      delete this.eventData['updatedOn'];
      if (this.eventData.eventStartDate != null) {
        this.eventData.eventStartDate = new Date(this.eventData.eventStartDate);
      }
      if (this.eventData.eventEndDate != null) {
        this.eventData.eventEndDate = new Date(this.eventData.eventEndDate);
      }
      this.appService.updateTodaysEvent(this.eventData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddEventPopup.close();
            this.ngOnChanges();
          }

          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }

  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByemailAddress: any = null;
  searchByDesignationCode: any = [];
  searchByDepartmentCode: any = [];
  searchUsersChildCheckBoxs = false;
  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  popupTitle: any = '';
  searchUserFunction() {
    this.getSelectedUserId = [];
    this.getSelectedUserName = [];

    this.getSelectedUserId.push(Number(this.message.getUserId()));
    this.getSelectedUserName.push(localStorage.getItem("loggedUserName"));
    this.searchUsersChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.popupTitle = "Search User";
    this.eventData.involvedUserIds = null;
    this.eventData.involvedUserNames = null;
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = [];
    this.getSelectedUserName = [];
    this.eventData.involvedUserIds = Number(this.message.getUserId());
    this.eventData.involvedUserNames = localStorage.getItem("loggedUserName");
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.isProcessing = true;
    let formattedUserName = '';

    if (this.searchByUserName) {
      formattedUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }

    const searchOneQmsUserVwDetails = {
      userName: formattedUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      emailAddress: this.searchByemailAddress,
      designationCode: this.searchByDesignationCode?.length ? this.searchByDesignationCode[0].valueExp : '',
      departmentCode: this.searchByDepartmentCode?.length ? this.searchByDepartmentCode[0].valueExp : '',
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  priviousSelectedValue: any;
  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;
  searchUserDataGridParentCheckBoxChecked(e: any): void {
    const isChecked: boolean = e.target.checked === true;
    this.getSelectedUserId = [];
    this.getSelectedUserName = [];
    for (const user of this.getOneQmsUsersVwDetailsTableData ?? []) {
      user.searchUserChildCheckBoxs = isChecked;
      if (isChecked) {
        this.getSelectedUserId.push(user.userId);
        this.getSelectedUserName.push(user.userName);
      }
    }
  }

  getSelectedUserId: any = [];
  getSelectedUserName: any = [];

  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      if (!this.getSelectedUserId?.includes(listOfUsersVwDetails.userId)) {
        this.getSelectedUserId.push(listOfUsersVwDetails.userId);
        this.getSelectedUserName.push(listOfUsersVwDetails.userName);
      }


    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId.splice(this.getSelectedUserId.indexOf(listOfUsersVwDetails.userId), 1);
      this.getSelectedUserName.splice(this.getSelectedUserName.indexOf(listOfUsersVwDetails.userName), 1);

    }

  }

  getOneQmsUsersVwDetailsTableData: any = [];
  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByemailAddress = null;
    this.searchByDesignationCode = [];
    this.searchByDepartmentCode = [];
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  selectBoxeForDesignationCode(): void {
    for (const item of this.dropDownForDesignationCode ?? []) {

      this.designationCodeDropdown.push({
        valueExp: item.codelistName,
        displayExp: item.codelistName
      });
    }
  }

  selectBoxeForDepartmentCode(): void {
    for (const item of this.dropDownForDepartmentCode ?? []) {
      this.departmentCodeDropdown.push({
        valueExp: item.codelistName,
        displayExp: item.codelistName
      });
    }
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;

  onDesignationCodeSelect(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  title: any;
  addUserNameFunction() {
    this.eventData.userId = this.getSelectedUserId;
    this.eventData.userName = this.getSelectedUserName;
    const selectedIdsString = (this.getSelectedUserId ?? []).join(",");

    if (selectedIdsString) {
      this.eventData.involvedUserIds = this.eventData.involvedUserIds
        ?
        `${this.eventData.involvedUserIds},${selectedIdsString}` : selectedIdsString;
    }

    const selectedNamesString = (this.getSelectedUserName ?? []).join(",");

    if (selectedNamesString) {
      this.eventData.involvedUserNames = this.eventData.involvedUserNames
        ?
        `${this.eventData.involvedUserNames},${selectedNamesString}` : selectedNamesString;
    }
    this.visibleSearchUserPopup.close();
  }
  cancelEventFunction() {
    this.visibleAddEventPopup.close();
  }

  openDeletePopup(eventData: any, event: any) {
    event.stopPropagation();
    this.eventData = eventData;
    this.eventData['deleteReason'] = "";
    this.title = "Delete Event";
    this.visibleDeleteEventPopup = this.dialog.open(this.deleteEventPopup, this.deleteEventPopupConfig);
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.eventData['deleteReason'] == "") {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      this.eventData['sessionUserId'] = this.message.getUserId();
      delete this.eventData['createdOn'];
      delete this.eventData['updatedOn'];
      if (this.eventData.eventStartDate != null) {
        this.eventData.eventStartDate = new Date(this.eventData.eventStartDate);
      }
      if (this.eventData.eventEndDate != null) {
        this.eventData.eventEndDate = new Date(this.eventData.eventEndDate);
      }
      this.appService.deleteTodaysEvent(this.eventData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.deleteValidation();

          }
          this.visibleDeleteEventPopup.close();
          this.ngOnChanges();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });

    }

  }

  deleteReason: any;

  deleteReasonRequiredMsg: any;

  deleteValidation() {
    this.deleteReason = document.getElementById('deleteReason') as HTMLInputElement;

    this.deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.eventData.deleteReason == "") {
      this.deleteReason.style.border = '1px solid red';
      this.deleteReasonRequiredMsg.style.display = 'block';
    } else {
      this.deleteReason.style.border = 'none';
      this.deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  cancelDeleteFunction(): void {
    this.visibleDeleteEventPopup?.close();
  }


}
